var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        "show-footer": "",
        "ok-text": "Save",
        title: _vm.id
          ? _vm.$t("chatbotv2.editEntries")
          : _vm.$t("chatbotv2.newEntries"),
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
        ok: _vm.saveButtonClickHandler,
      },
    },
    [
      _c("div", { attrs: { id: "cb-entries" } }, [
        _c(
          "div",
          { staticClass: "error-message-container" },
          [
            _vm.isError
              ? _c("a-alert", {
                  attrs: {
                    message: _vm.errorMessage,
                    type: "error",
                    "show-icon": "",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isSave
              ? _c("a-alert", {
                  attrs: {
                    message: _vm.saveMessage,
                    type: "success",
                    "show-icon": "",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-content" }, [
          _c("div", { staticClass: "title-form-head" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.entitiesName,
                  expression: "entitiesName",
                },
              ],
              staticClass: "form-input",
              attrs: { placeholder: _vm.$t("chatbotv2.entryName") },
              domProps: { value: _vm.entitiesName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.entitiesName = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "synonyms" }, [
            _c("div", { staticClass: "synonyms-title" }, [
              _c("div", [_vm._v(_vm._s(_vm.$t("chatbotv2.entries")))]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "add-button",
                  on: { click: _vm.addEntryClickHandler },
                },
                [_c("md-icon", [_vm._v("add")])],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "synonyms-list" }, [
              _vm.entries.length <= 0
                ? _c("div", { staticClass: "empty-list" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("chatbotv2.youHaveNoEntries")) +
                        "\n                    "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "list-wrapper" },
                _vm._l(_vm.entries, function (entry, index) {
                  return _c("EntriesListItem", {
                    key: "" + index,
                    attrs: {
                      "initial-data": entry,
                      open: _vm.openedEntryId === entry.value,
                      "on-opened": function () {
                        return (_vm.openedEntryId = entry.value)
                      },
                      "on-closed": function () {
                        return (_vm.openedEntryId = null)
                      },
                    },
                    on: {
                      "delete-entry": function ($event) {
                        return _vm.deleteEntry(index)
                      },
                      "update-entry": function (args) {
                        return _vm.updateEntry(args, index)
                      },
                      error: _vm.sendError,
                    },
                  })
                }),
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }